/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planmembersrow2Inputs */

const en_planmembersrow2 = /** @type {(inputs: Planmembersrow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage members and members-only events`)
};

const de_planmembersrow2 = /** @type {(inputs: Planmembersrow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder verwalten und Events nur für Mitglieder`)
};

/**
* | output |
* | --- |
* | "Manage members and members-only events" |
*
* @param {Planmembersrow2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planmembersrow2 = /** @type {((inputs?: Planmembersrow2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planmembersrow2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planmembersrow2(inputs)
	return de_planmembersrow2(inputs)
});
export { planmembersrow2 as "planMembersRow" }